import { AuthSuccessGrant } from '@chegg/wtf-components'
import { AuthEventData } from '@chegg/wtf-components/dist/types/opencomponents/cheggAuth'
import { PayloadAction, EmptyAction } from 'typesafe-actions'

export interface AuthMethods {
  trigger: (type: string, arg?: any) => void
  on: (type: string, callback: (event: Event, arg: any) => void) => void
}
export interface AuthLogicParams {
  permittedOrigin?: string
}

export const AUTH_FRAME_READY = 'AUTH_FRAME_READY'
export const AUTH_FRAME_AUTH_SUCCESSFUL = 'AUTH_FRAME_AUTH_SUCCESSFUL'
export const AUTH_FRAME_AUTH_EVENT = 'AUTH_FRAME_AUTH_EVENT'
export const AUTH_FRAME_CLOSED = 'AUTH_FRAME_CLOSED'

/**
 * The code in this function is meant to depend only on the values from its
 * inputs and the resources available in the iframe (globals), not from the UCF
 * codebase itself. Don't expect to be able to import methods from anywhere.
 *
 * Ideally we're coding to ES5 standards in this function to ensure maximum
 * compatibility with browsers, but, the code below is being transpiled by
 * the time it reaches the user, so, some things like types and other
 * transpilable features should work.
 */
/* eslint-disable no-var */
function authLogic(params: AuthLogicParams) {
  var AUTH_FRAME_READY = 'AUTH_FRAME_READY'
  var AUTH_FRAME_AUTH_SUCCESSFUL = 'AUTH_FRAME_AUTH_SUCCESSFUL'
  var AUTH_FRAME_AUTH_EVENT = 'AUTH_FRAME_AUTH_EVENT'
  var AUTH_FRAME_CLOSED = 'AUTH_FRAME_CLOSED'
  var permittedOrigin = params.permittedOrigin
    ? params.permittedOrigin
    : window.location.origin
  function dispatch(
    action: PayloadAction<string, AuthSuccessGrant | AuthEventData> | EmptyAction<string>
  ) {
    window.parent.postMessage(action, permittedOrigin)
  }
  function cheggAuthReady(event: Event, auth: AuthMethods) {
    dispatch({ type: AUTH_FRAME_READY })
    auth.trigger('disable redirect', true)
    auth.on('auth successful', function (event: Event, saOptions: AuthSuccessGrant) {
      dispatch({ type: AUTH_FRAME_AUTH_SUCCESSFUL, payload: saOptions })
    })
    auth.on('auth event', function (event: Event, saOptions: AuthEventData) {
      dispatch({ type: AUTH_FRAME_AUTH_EVENT, payload: saOptions })
    })
    auth.on('hidden', function () {
      dispatch({ type: AUTH_FRAME_CLOSED })
    })
  }

  function shellLoaded() {
    if (window.globalCheggAuth) {
      cheggAuthReady(null, window.globalCheggAuth)
    } else {
      window.oc.events.on('chegg-auth-ready', cheggAuthReady)
    }
  }

  // sendCommand
  window.oc = window.oc || ({} as Window['oc'])
  window.oc.cmd = window.oc.cmd || []
  window.oc.cmd.push(shellLoaded)
}
/* eslint-enable no-var */

export default authLogic
